/** 数据修正 */
export default {
    openId: "ไอดีเปิด", // 开放id
    openIdPlaceholder: "ไอดีเปิด", // 请输入开放id
    organisation: "องค์กร", // 组织架构
    organisationName: "ชื่อองค์กร", // 组织名称
    organisationNamePlaceholder: "ชื่อองค์กร", // 请输入组织名称 
    affiliatedOrganisation: "องค์กรที่เกี่ยวข้อง", // 所属组织
    entity: "ร้านค้า", // 实体
    entityId: "ไอดีส่วนร่าง", // 实体id
    entityName: "ชื่อร้าน", // 实体名称 entity name
    entityNamePlaceholder: "ชื่อร้าน", // 请输入实体名称
    sortNumber: "sort number", // 实体排序
    entityType: "ประเภทร้าน", // 实体类型
    businessHours: "เวลาทำการ", // 营业时间
    businessStartTime: "เวลาเริ่มทำการ", // 营业开始时间
    closingTime: "เวลาปิด", // 营业结束时间
    passagewayName: "ชื่อประตู", // 出入口名称 Entry and exit management
    passagewayNamePlaceholder: "ชื่อประตู", // 请输入出入口名称
    maximumCapacity: "ความจุสูงสุด", // 最大容纳人数
    maxInstant: "จำนวนคนสูงสุดทันที", // 最大瞬时人数
    inWarningNum: "แจ้งเตือนล่วงหน้าจำนวนคนเข้า", // 预警进人数
    passengerBasic: "ฐานการไหลของผู้โดยสาร", // 客流基数
    totalPassenger: "จำนวนผู้โดยสารทั้งหมด", // 总客流人数
    today: "วันนี้วันที่", // 今日日期
    storePhone: "หมายเลขโทรศัพท์ของร้าน", // 门店电话
    linker: "ชื่อผู้ติดต่อ", // 联系人姓名
    linkerPlaceholder: "ชื่อผู้ติดต่อ", // 请输入联系人姓名
    address: "ที่อยู่", // 详细地址
    linkerPhone: "ติดต่อโทรศัพท์มือถือ", // 联系人手机
    entryNumber: "จำนวนผู้เข้า", // 进人数 walk into
    exitNumber: "จำนวนผู้ออก", // 出人数 walk out
    passingsNumber: "จำนวนผู้ผ่าน", // 经过人数 walk pass
    returnNumber: "จำนวนการโอนคืน", // 折返人数
    manNumber: "จำนวนผู้ชาย", // 男客流量
    girlNumber: "จำนวนผู้หญิง", // 女客流量
    strandNumber: "จำนวนคนที่อยู่", // 滞留人数 people staying
    whetherToCalculate: "ต้องการคำนวณหรือไม่", // 是否需要计算 Whether to calculate
    needToCalculate: "ต้องการคำนวณ", // 需要计算
    noNeedToCalculate: "ไม่ต้องการคำนวณ", // 不需要计算
    currentOneMinute: "หนึ่งนาทีปัจจุบัน", // 一分钟时间
    currentFiveMinute: "ห้านาทีปัจจุบัน", // 所在五分钟
    currentHour: "ชั่วโมงปัจจุบัน", // 所在小时
    currentDate: "วันปัจจุบัน", // 所在天
    currentWeek: "สัปดาห์ปัจจุบัน", // 所在周
    currentMonth: "เดือนปัจจุบัน", // 所在月
    currentYear: "ปีปัจจุบัน", // 所在年
    searchTime: "เวลาค้นหา", // 搜索时间
    startTime: "เวลาเริ่ม", // 开始时间
    endTime: "เวลาสิ้นสุด", // 结束时间
    serialNumber: "หมายเลขลำดับ", // 序列号
    serialNumberPlaceholder: "หมายเลขลำดับ", // 请输入序列号
    equipmentAlias: "ชื่อย่ออุปกรณ์", // 设备别名
    warrantyExpirationDate: "วันหมดประกัน", // 质保到期
    serviceExpirationDate: "วันหมดอายุบริการ", // 服务到期
    model: "โมเดล", // 型号
    versionNumber: "หมายเลขเวอร์ชัน", // 版本号
    iccid: "sim iccid", // SIM 卡号
    onlineState: "สถานะออนไลน์", // 在线状态
    isBind: "not bind passageway", // 是否绑定出入口
    bindPassageway: "ผูกประตู", // 绑定出入口
    transmitterPower: "พลังงานส่ง", // 发射端电量
    receiverPower: "พลังงานรับ", // 接收端电量
    heartbeatTime: "เวลาการส่งสัญญาณ", // 心跳时间
    reportedTime: "เวลารายงานล่าสุด", // 最后上报时间
    learningStatus: "สถานะการเรียนรู้", // 学习状态
}
